import { memo } from "react";

import { Button } from "@/components/ui/button";

import type { IShareInviteSelectionFooterProps } from "./types";

// NOTE: NSAI-7350 — the pending-selection summary lives at the foot of the
// members panel rather than above the field. Above the field it appeared with
// the first pick and pushed the whole dialog down; inside the overlay panel it
// costs the layout nothing.
const ShareInviteSelectionFooterComponent = ({
  selectedCountLabel,
  clearAllLabel,
  onClearAll,
}: IShareInviteSelectionFooterProps): JSX.Element => (
  <div className="flex items-center justify-between gap-3 border-t px-3 py-2 text-xs text-muted-foreground">
    <span data-testid="share-selected-count">{selectedCountLabel}</span>
    <Button
      type="button"
      variant="link"
      onClick={onClearAll}
      className="h-auto p-0 text-xs font-medium underline-offset-2"
    >
      {clearAllLabel}
    </Button>
  </div>
);

export const ShareInviteSelectionFooter = memo(
  ShareInviteSelectionFooterComponent,
);

ShareInviteSelectionFooter.displayName = "ShareInviteSelectionFooter";
